import { FCM_SERVICE_WORKER_SCRIPT } from "./fcm-constant";

/**
 * Unregister the Firebase messaging service worker so the device stops
 * receiving push notifications after logout. Errors are swallowed so a
 * failure here can never block the logout flow.
 */
export const unregisterFcmServiceWorker = async (): Promise<void> => {
  try {
    if (!("serviceWorker" in navigator)) return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((registration) =>
          registration.active?.scriptURL?.includes(FCM_SERVICE_WORKER_SCRIPT)
        )
        .map((registration) => registration.unregister())
    );
  } catch (e) {
    console.error("Failed to unregister FCM service worker", e);
  }
};
